@import 'vars';
@import 'mixins';
@import 'typography/softphone';

$modal-margin: 40px;
$header-sidebar-size: 40px;
$title-height: 40px;

// Gives us an additional pixel of padding to prevent any MUI labels being cut off
$close-icon-offset: 1px;
$mui-label-gutter: 1px;
$top-padding: $padding-small - $mui-label-gutter;

.softphone-modal {
  // This is an edge case to cater for MUI hoisting the softphone code outside the LayoutContext
  @include softphone-typography;

  margin: 0 0 0 #{$modal-margin};
  width: calc(100vw - #{$header-sidebar-size});
  max-width: calc(#{$softphone-max-width} - #{$header-sidebar-size});

  &--forced {
    width: calc(100vw - #{$header-sidebar-size});
    max-width: calc(#{$forced-softphone-max-width} - #{$header-sidebar-size});
  }

  &__close-button {
    padding-top: $close-icon-offset;
  }

  &__title {
    height: $title-height;
    min-height: $title-height;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  &__subtitle {
    text-align: left;
    margin-bottom: $margin-small;

    &--text {
      font-size: $font-size-small-softphone;
    }
  }

  &--reversed {
    margin: 0 #{$modal-margin} 0 0;
  }

  &__content {
    padding: $top-padding $padding-small $padding-small;
    display: flex;
    flex-direction: column;
    flex: 1;
    background: $white;
    height: 100%;
    padding-top: 0;
    overflow-x: hidden;

    &__children {
      min-height: 0;
      margin-bottom: auto;
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    &__footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 10px;
      gap: 20px;

      &--invert-buttons {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        justify-content: flex-start;
        gap: $gap-large;
        margin-top: $gap-small;
      }
    }
  }
}
